import React from 'react';

const Rating = ({ rateLevelAmount, rating, isFullStar }) => {
  const isLevelReached = (rate, level) => {
    let isRateReachesLevel = (rate - level).toFixed(1);
    return isRateReachesLevel >= 0 ? 1 : isRateReachesLevel > -1 ? (1 - isRateReachesLevel * -1).toFixed(1) : 0;
  };

  return (
    <div className="rating">
      <div className="rate">
        {[...Array(rateLevelAmount)].map((el, i) => {
          const isRateReachesLevel = isLevelReached(rating, i + 1);
          return (
            <div
              className={`rate-level ${isFullStar && isRateReachesLevel ? 'fas' : 'far'}`}
              key={i}
              {...(isRateReachesLevel && { 'data-is-level-reached': isRateReachesLevel })}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Rating;
